<script setup>
import { computed, normalizeClass, useAttrs } from 'vue'
import { CircleHelp } from 'lucide-vue-next'
import { APP_ICONS } from './app-icon-components'
import { BRAND_ICON_PATHS } from './app-icon-brand-paths'

defineOptions({
    inheritAttrs: false,
})

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
})

const attrs = useAttrs()
const brandPath = computed(() => BRAND_ICON_PATHS[props.name] ?? null)
const attributeClasses = computed(() => normalizeClass(attrs.class).split(/\s+/).filter(Boolean))
const hasSizeClass = (axis) =>
    attributeClasses.value.some((className) => {
        const utility = className.split(':').at(-1).replace(/^!/, '')
        return utility.startsWith(`${axis}-`) || utility.startsWith('size-')
    })
const iconClasses = computed(() => [
    'inline-block shrink-0 align-middle',
    {
        'h-[1em]': !hasSizeClass('h'),
        'w-[1em]': !hasSizeClass('w'),
    },
])
const resolvedIcon = computed(() => {
    const component = APP_ICONS[props.name]

    if (!component) {
        console.warn(`Missing Lucide equivalent for icon: ${props.name}`)
        return CircleHelp
    }

    return component
})
</script>

<template>
    <svg
        v-if="brandPath"
        viewBox="0 0 24 24"
        fill="currentColor"
        :class="iconClasses"
        aria-hidden="true"
        v-bind="attrs"
    >
        <path :d="brandPath" />
    </svg>
    <component
        :is="resolvedIcon"
        v-else
        :class="iconClasses"
        aria-hidden="true"
        v-bind="attrs"
    />
</template>
